if (!customElements.get('community-gallery')) {
  customElements.define(
    'community-gallery',
    class CommunityGallery extends HTMLElement {
      constructor() {
        super();
        this.grid = this.querySelector('.community-gallery__grid');
        if (!this.grid) return;

        this.isDown = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.dragged = false;

        this.grid.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.grid.addEventListener('mouseleave', this.onMouseUp.bind(this));
        this.grid.addEventListener('mouseup', this.onMouseUp.bind(this));
        this.grid.addEventListener('mousemove', this.onMouseMove.bind(this));
        this.grid.addEventListener(
          'click',
          (event) => {
            if (this.dragged) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );
      }

      onMouseDown(event) {
        this.isDown = true;
        this.dragged = false;
        this.startX = event.pageX - this.grid.offsetLeft;
        this.scrollLeft = this.grid.scrollLeft;
      }

      onMouseUp() {
        this.isDown = false;
      }

      onMouseMove(event) {
        if (!this.isDown) return;
        event.preventDefault();
        const x = event.pageX - this.grid.offsetLeft;
        const walk = x - this.startX;
        if (Math.abs(walk) > 5) this.dragged = true;
        this.grid.scrollLeft = this.scrollLeft - walk;
      }
    }
  );
}
